import {cachePromise} from './cache_promise';

export default function createGenericFetchService(options) {
  return cachePromise(function(params) {
    var queryParams = Object.assign(options.defaultParams, params);
    return $.getJSON(options.pathHelper(queryParams));
  });
}

// Premium Upgrade Page
export const ReadEventCountService = createGenericFetchService({
  defaultParams: {
    user_id: Aedu.User.current && Aedu.User.current.id,
    subdomain_param: "api"
  },
  pathHelper: $r.total_count_api_v0_readers_path,
});

export const SearchAdvancedSampleNameMentionService = createGenericFetchService({
  defaultParams: {
    subdomain_param: "api"
  },
  pathHelper: $r.sample_name_mention_api_v0_mentions_path,
});

export const ProfileVisitorsCountService = createGenericFetchService({
  defaultParams: {
    user_id: Aedu.User.current && Aedu.User.current.id,
    subdomain_param: "api"
  },
  pathHelper: $r.total_count_api_v0_profile_visitors_path,
});

export const  UnseenProfileVisitorsCountService = createGenericFetchService({
  defaultParams: {
    user_id: Aedu.User.current && Aedu.User.current.id,
    subdomain_param: "api"
  },
  pathHelper: $r.has_unseen_api_v0_profile_visitors_path,
});
